import React, { useEffect, useState } from 'react'
import { TextAreaProps } from './TextArea.props'
import {
  TextAreaCharacter,
  TextAreaContainer,
  TextAreaLabel,
  TextAreaLabelContainer,
  TextAreaSpan,
  TextAreaStyled,
  TextAreaStyledContainer,
} from './TextArea.styled'

const TextArea = ({
  label,
  required = false,
  size = 350,
  maxLength,
  value,
  onTextChange,
}: TextAreaProps) => {
  const [values, setValues] = useState<string>(value as string)
  const handleChange = (evt: React.ChangeEvent<HTMLTextAreaElement>) => {
    const text = evt.currentTarget.value
    setValues(text)
    if (onTextChange) onTextChange(text)
  }

  useEffect(() => {
    setValues(value as string)
  }, [value])

  return (
    <TextAreaContainer>
      <TextAreaLabelContainer>
        {label && (
          <TextAreaLabel>
            {label}
            {required && <TextAreaSpan>*</TextAreaSpan>}
          </TextAreaLabel>
        )}
        <TextAreaStyledContainer>
          <TextAreaStyled
            size={size}
            maxLength={maxLength}
            value={values}
            onChange={handleChange}
          />
          {maxLength && (
            <TextAreaCharacter>
              {values ? values.length : 0} / {maxLength}
            </TextAreaCharacter>
          )}
        </TextAreaStyledContainer>
      </TextAreaLabelContainer>
    </TextAreaContainer>
  )
}

export default TextArea
